import './App.css';

function App() {
  return (
    <div className="App">
      <h1>笨笨最可爱</h1>
    </div>
  );
}

export default App;
